var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "checkout-project-info-page-container" }, [
      _c("section", { staticClass: "text-center bg-white main-heading-page" }, [
        _c("h2", [
          _vm._v(
            "                    \n                " +
              _vm._s(_vm.$resourceString["checkout.Title.ProjectInformation"]) +
              "                    \n            "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row align-items-start" }, [
          _c("div", { staticClass: "col-12 col-lg-8 col-xl-9" }, [
            _c("div", { staticClass: "checkout-project-info-page-wrap" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c(
                    "h5",
                    { staticClass: "primary-heading font-weight-bold" },
                    [
                      _vm._v(
                        "\n                                    " +
                          _vm._s(
                            _vm.$resourceString[
                              "checkout.ProjectInformation.Title.MainHeading"
                            ]
                          ) +
                          " \n                                    "
                      ),
                      _c("span", { staticClass: "required-label" }, [
                        _vm._v(
                          _vm._s(_vm.$resourceString["common.Label.Required"])
                        )
                      ])
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "div",
                    { staticClass: "checkout-project-info-page-details" },
                    [
                      _c(
                        "div",
                        { staticClass: "checkout-project-info-page-form" },
                        [
                          _c("pc-salesforce-opportunities", {
                            attrs: {
                              "user-email": _vm.userEmail,
                              "edit-opportunities-data": _vm.opportunityData
                            },
                            on: {
                              "contact-found": _vm.handleContactFound,
                              "update-project-name": _vm.updateProjectName,
                              "update-loader": _vm.handleUpdateLoader,
                              "update-is-enabled": _vm.handleIsEnabled
                            }
                          }),
                          _vm._v(" "),
                          _vm.contactFound !== null &&
                          _vm.contactFound === false
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "checkout-project-info-select-project-col"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "checkout-project-info-select-project form-group-control"
                                    },
                                    [
                                      _c("label", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$resourceString[
                                              "checkout.Project.Title"
                                            ]
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "form-input-box" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.projectName,
                                                expression: "projectName"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "text",
                                              id: "enternewproject",
                                              name: "enternewproject",
                                              placeholder:
                                                _vm.$resourceString[
                                                  "checkout.Placeholder.ProjectName"
                                                ]
                                            },
                                            domProps: {
                                              value: _vm.projectName
                                            },
                                            on: {
                                              input: [
                                                function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.projectName =
                                                    $event.target.value
                                                },
                                                _vm.submitProjectName
                                              ]
                                            }
                                          }),
                                          _vm._v(" "),
                                          _vm.getValidationErrorPName
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "field-validation-error text-secondary"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                       " +
                                                      _vm._s(
                                                        _vm.$resourceString[
                                                          "checkout.ProjectName.ValidationError"
                                                        ]
                                                      ) +
                                                      "\n                                                    "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 col-lg-4 col-xl-3 sidebar-position-sticky" },
            [
              _c("div", { staticClass: "checkout-basket-sidebar-warpper" }, [
                _c(
                  "div",
                  { staticClass: "checkout-basket-sidebar-container" },
                  [
                    _c("pc-basket-sidebar", {
                      attrs: {
                        individualSamples:
                          _vm.checkoutItemList.siteItems.length > 0,
                        individualSamplesCount: _vm.checkoutItemCount.siteItems,
                        projectSamples:
                          _vm.checkoutItemList.projectItems.length > 0,
                        projectSamplesCount: _vm.checkoutItemCount.projectItems,
                        designTraySample:
                          _vm.checkoutItemList.trayItems.length > 0,
                        designTraySampleCount: _vm.checkoutItemCount.trayItems,
                        backLabel:
                          _vm.$resourceString["checkout.Button.BackToShipping"],
                        backAction: _vm.backHandler,
                        nextLabel:
                          _vm.$resourceString["checkout.Button.ReviewBasket"],
                        nextAction: _vm.nextHandler,
                        isNextDisabled:
                          !this.checkoutData.ProjectName || !_vm.isProjectValid,
                        isError:
                          !_vm.isProjectValid || _vm.getValidationErrorPName,
                        errorMsg: _vm.isProjectValidError
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }